<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <div @click="openVisaModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">ENTRY REQUIREMENTS</h4>
            <div class="nav-text-center">
              <i class="icon-prerequisite vtd-icon-7" />
            </div>
          </div>
          <Visa ref="VisaRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div
          class="vtd-card vtd-animate-shake"
          @click="openTravelInsuranceModal"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">TRAVEL INSURANCE</h4>
            <div class="nav-text-center">
              <i class="icon-travel_insurance_light vtd-icon-7" />
            </div>
          </div>
          <Insurance ref="Insurance" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click="openTravelHealthModal">
          <div class="navigation-block">
            <h4 class="nav-title-center">TRAVEL HEALTH</h4>
            <div class="nav-text-center">
              <i class="icon-travel_health vtd-icon-7" />
            </div>
          </div>
          <TravelHealth ref="TravelHealthRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake">
          <div class="navigation-block" @click="openFAQsModal">
            <h4 class="nav-title-center">FAQs</h4>
            <div class="nav-text-center">
              <i class="icon-faq vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <HomeBackBtns />
    <Faq ref="FaqRef" />
  </HomeLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HomeLayout from '@/partials/home-layout'
import Insurance from '@/modules/navigation/modals/insurance'
import Visa from '@/modules/menu-bar/essential-info/visa'
import Faq from '@/modules/booking/faq'
import TravelHealth from '@/modules/menu-bar/essential-info/travel-health'

export default {
  components: {
    HomeLayout,
    Insurance,
    Visa,
    Faq,
    TravelHealth,
  },
  async created() {
    const loginRes = await this.loginOnStart({
      username: this.$route.params.surname,
      bookingNumber: this.$route.params.bookingNumber,
      source: this.$route.params.source,
    })
    if (!loginRes) {
      this.$router.push('/login')
    }
  },
  mounted() {
    this.stopLoading()
  },
  computed: {
    ...mapGetters({ essentialInfoMenu: 'essentialInfoMenu/getMenu' }),
  },
  methods: {
    ...mapActions({
      loginOnStart: 'auth/loginBookingNumberOnStartAction',
    }),
    openPassportModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'VisaRef') {
          this.$refs.PassportRef.showModal(this.essentialInfoMenu[index])
          this.$root.$on('visaadvice', () => {
            this.$refs.PassportRef.showModal(this.essentialInfoMenu[index])
          })
        }
      }
    },
    openVisaModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'VisaRef') {
          this.$refs.VisaRef.showModal(this.essentialInfoMenu[index])
          this.$root.$on('visaadvice', () => {
            this.$refs.VisaRef.showModal(this.essentialInfoMenu[index])
          })
        }
      }
    },
    openTravelInsuranceModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.title === 'Travel Insurance') {
          this.$refs.Insurance.showModal(this.essentialInfoMenu[index])
        }
      }
    },
    openFAQsModal() {
      this.$refs['FaqRef'].showModal()
    },
    openTravelHealthModal() {
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'TravelHealthRef') {
          this.$refs.TravelHealthRef.showModal(this.essentialInfoMenu[index])
          this.$root.$on('travelhealth', () => {
            if (
              this.$refs &&
              this.$refs.TravelHealthRef &&
              this.$refs.TravelHealthRef.showModal
            ) {
              this.$refs.TravelHealthRef.showModal(
                this.essentialInfoMenu[index],
              )
            }
          })
        }
      }
    },
    stopLoading() {
      this.$emit('loading-bar', false)
    },
  },
}
</script>
